import { FormikProps } from "formik";
import { ITextEdit } from "../../interfaces/common";
import { get } from "lodash";

const InputField = <U,>({
  formik,
  config,
  disabled,
  value,
}: {
  formik: FormikProps<any>;
  config: Omit<ITextEdit<U>, "label">;
  disabled?: boolean;
  value?: string;
}) => {
  const { id, placeholder } = config;
  const { values, handleBlur, handleChange } = formik;
  const wasTouched = get(formik.touched, id);
  const errorMessage = get(formik.errors, id) as string | undefined;
  return (
    <div
      className={`${
        disabled ? "bg-light" : "bg-white"
      } border border-secondary rounded d-flex h-100`}
    >
      {!disabled && (
        <input
          autoComplete="off"
          placeholder={placeholder ? placeholder : ""}
          type="text"
          id={id}
          className={`form-control ${
            wasTouched && errorMessage ? "is-invalid" : ""
          }`}
          value={value ?? values[id]}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default InputField;
